// @ts-nocheck
import { Box, IconButton, List, ListItem, ListItemText, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CommonHeading from "../../components/commonComponents/commonHeading";
import CommonBreadcrumbs from "../../components/commonComponents/CommonBreadcrumbs";
import { useNavigate } from "react-router-dom";
import { getTransactionHistory } from "../../redux/slice/fundAndTransactionSlice";
import { useDispatch, useSelector } from "react-redux";
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from "../../services/AuthContext";
import DateFormatter from "../../utils/DateFormater";
import NumberFormatter from "../../utils/NumberFormater";
import DynamicDialog from "../../components/DynamicDialogBox";
import Loading from "../../components/Loading";
import { BackButton } from "../../components/commonComponents/BackButton";
const handleGenerateResponse = (status, style) => {
  const lowerCaseStatus = status.toLowerCase()
  if (lowerCaseStatus === "in progress" || lowerCaseStatus === "in-progress") {
    return <span style={{ color: "#3B3B3B", ...style }} >In-progress</span>
  } else if (lowerCaseStatus === "failed" || lowerCaseStatus === "rejected" || lowerCaseStatus === "canceled") {
    return <span style={{ color: "#EF233C", ...style, textTransform: "capitalize" }} >{status}</span>
  } else {
    return <span style={{ color: "#28A745", ...style }} >{status}</span>
  }
}
const TransactionHistory = () => {
  const navigate = useNavigate()
  const [open, setOpen] = useState(false);
  const [payload, setPayload] = useState({})
  const [loading, setLoading] = useState(false)
  const { transactionHistory } = useSelector((store) => store.fund)
  const { investorId: user } = useAuth()
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchTransactionHistory = async () => {
      if (user.investorId) {
        setLoading(true);
        try {
          await dispatch(getTransactionHistory(user.investorId)).unwrap();
        } catch (error) {
          console.error("Error fetching transaction history:", error);
        } finally {
          setLoading(false);
        }
      }
    };
  
    fetchTransactionHistory();
  }, [user.investorId]);

  const appBreadCrumbs = [
    {
      href: "",
      label: "Home",
      onClick: () => {
        navigate("/home")
      }
    },
    {
      href: "",
      label: "Manage Funds",
      onClick: () => {
        navigate("/managefunds")
      }
    },
  ];
  let options = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true
  };
  const onClose = () => {
    setOpen(false)
  }
  const handleOpenDialog = (item) => {
    console.log(item)
    setOpen(true)
    setPayload(item)
  }
  return (
    <>
    <div className='flex justify-start items-center'>
    <BackButton/>
    </div>
    <Box>
      <CommonBreadcrumbs
        items={appBreadCrumbs}
        final={{
          href: "",
          label: "Transaction History",
        }}
      />
      <Box bgcolor={"#fff"} display={"flex"} justifyContent={"space-between"} px={2.5} py={"15px"} alignItems={"center"} mb={1}>
        <CommonHeading
          sx={{ fontSize: { lg: "26px" }, fontWeight: "600" }}
          heading={"Transaction History"}
        />
        <IconButton sx={{ p: 0 }} onClick={() => navigate(-1)}>
          <CloseIcon />
        </IconButton>

      </Box>
      <Box>
        {!loading ? <List sx={{ width: "100%" }}>
          {transactionHistory.length > 0 && transactionHistory.map((item) => (
            <Box
              bgcolor={"#fff"}
              borderRadius={1}
              mb={1}
              key={item.id}
              sx={{ boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.1)" , cursor:"pointer"}}
              onClick={() => handleOpenDialog(item)}
            >
              <ListItem sx={{ px: 3, py: 1.25 }}>
                <ListItemText
                  sx={{ m: 0 }}
                  primary={
                    <Box display={"flex"} justifyContent={"space-between"}>
                      <Box>
                        <Typography
                          fontWeight={500}
                          color={"#3B3B3B"}
                          fontSize={{ md: 18, }}
                          variant="body2"
                        >
                          {item.description || item.Type}
                        </Typography>
                      </Box>
                      <Box fontWeight={600} color={"#3B3B3B"} fontSize={{ md: 18, }}>
                        $<NumberFormatter amount={item.amount} />
                      </Box>
                    </Box>
                  }
                  secondary={
                    <Box display={"flex"} mt={"12px"} justifyContent={"space-between"}>
                      <Box>
                        <Typography
                          fontWeight={500}
                          color={"#3B3B3B"}
                          fontSize={{ md: 14 }}
                          variant="body2"
                        >
                          {item.CompletedAt || item.CreatedAt || item.initiatedAt && <DateFormatter date={item.CompletedAt || item.CreatedAt || item.initiatedAt} />}
                        </Typography>
                      </Box>
                      <Box fontSize={{ md: 14 }}>{handleGenerateResponse(item.status, { fontSize: "inherit", fontWeight: 500, lineHeight: 1.5 })}</Box>
                    </Box>
                  }
                />
              </ListItem>
            </Box>
          ))}
        </List> : <Loading/>}

        {
          !loading && transactionHistory?.length == 0 &&
          <div className="min-h-80 flex justify-center items-center bg-white ">
          <Typography fontWeight={"500"} color="#9FA4AB" fontSize={14}> No information available</Typography></div>
        }
      </Box>

      <DynamicDialog open={open} onClose={onClose} payload={payload} />

    </Box>
    </>
  );
};

export default TransactionHistory;

